interface UnreadBadgeProps {
  count: number
  className?: string
  size?: 'sm' | 'md'
}

const sizeClasses = {
  sm: 'h-4 w-4 text-xs min-w-[16px]',
  md: 'h-5 w-5 text-xs min-w-[20px]',
}

export default function UnreadBadge({ count, className = '', size = 'md' }: UnreadBadgeProps) {
  if (count <= 0) return null

  return (
    <span
      className={`bg-red-500 text-white rounded-full flex items-center justify-center ${sizeClasses[size]} ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  )
}
